import React, { useContext } from "react";
import { GameStatus } from "../constants";

const initialState = {
  status: GameStatus.STOPPED,
  round: "firstRound",
  score: 0,
};

const ProgressContext = React.createContext(initialState);

function ProgressProvider({ children }) {
  const progress = React.useState({
    available: 0,
    dispatched: 0,
    total: 0,
  });

  return (
    <ProgressContext.Provider value={progress}>
      {children}
    </ProgressContext.Provider>
  );
}

export const useProgressContext = () => useContext(ProgressContext);

export default ProgressProvider;
